import { render, staticRenderFns } from "./rightList.vue?vue&type=template&id=b5af06f8&scoped=true&"
import script from "./rightList.vue?vue&type=script&lang=js&"
export * from "./rightList.vue?vue&type=script&lang=js&"
import style0 from "./rightList.vue?vue&type=style&index=0&id=b5af06f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5af06f8",
  null
  
)

export default component.exports